// draggable.js
function makeDraggable(container, handle, onClick) {
  let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
  let isDragging = false;

  // Mouse events
  handle.addEventListener("mousedown", dragStart, false);
  // Touch events
  handle.addEventListener("touchstart", dragStart, false);

  function dragStart(e) {
    e.preventDefault();

    if (e.type === "touchstart") {
      pos3 = e.touches[0].clientX;
      pos4 = e.touches[0].clientY;
    } else {
      pos3 = e.clientX;
      pos4 = e.clientY;
    }

    isDragging = false;

    document.addEventListener("mouseup", dragEnd, false);
    document.addEventListener("mousemove", dragMove, false);

    document.addEventListener("touchend", dragEnd, false);
    document.addEventListener("touchmove", dragMove, false);
  }

  function dragMove(e) {
    let clientX, clientY;

    if (e.type === "touchmove") {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }

    pos1 = pos3 - clientX;
    pos2 = pos4 - clientY;
    pos3 = clientX;
    pos4 = clientY;

    if (Math.abs(pos1) > 3 || Math.abs(pos2) > 3) {
      isDragging = true;
    }

    container.style.top = (container.offsetTop - pos2) + "px";
    container.style.left = (container.offsetLeft - pos1) + "px";
    container.style.bottom = "auto";
    container.style.right = "auto";
  }

  function dragEnd(e) {
    document.removeEventListener("mouseup", dragEnd, false);
    document.removeEventListener("mousemove", dragMove, false);

    document.removeEventListener("touchend", dragEnd, false);
    document.removeEventListener("touchmove", dragMove, false);

    // Only trigger click if there was no dragging
    if (!isDragging && typeof onClick === "function") {
      onClick();
    }
  }
}
